import data from '@/data/festivalData.json';

// Merge shows + installations into a single catalog, tagged by type.
export const ALL_ITEMS = [
  ...data.shows.map((s) => ({ ...s, tipus: 'espectacle' })),
  ...data.installations.map((s) => ({ ...s, tipus: 'installacio' })),
];

export const SHOWS = data.shows;
export const INSTALLATIONS = data.installations;

// Avisos de última hora: cualquier item con "cancelat": true en
// festivalData.json. Si no hay ninguno, los avisos no se pintan.
export const CANCELLED = ALL_ITEMS.filter((s) => s.cancelat);

// Mensaje de agradecimiento de cierre de edición. Se pinta como popup solo
// si "gracies": { "actiu": true } existe en festivalData.json. Para retirarlo
// basta con poner "actiu": false (o borrar el bloque entero).
export const GRACIES = data.gracies && data.gracies.actiu ? data.gracies : null;

// Fecha de la próxima edición. Se pinta en la portada, el pie y el mensaje de
// gracias solo si "proxima": { "actiu": true } existe en festivalData.json.
// Con "actiu": false desaparece de los tres sitios a la vez, sin dejar rastro.
export const PROXIMA = data.proxima && data.proxima.actiu ? data.proxima : null;

// Ediciones anteriores, para la rejilla de la portada. Salen del bloque
// "edicions" de festivalData.json, cada una con su año, su enlace al archivo y
// los tres colores de su campaña. Con "actiu": false una edición desaparece de
// la rejilla sin dejar rastro; añadir un año es añadir un objeto a la lista.
export const EDICIONS = (data.edicions || []).filter((e) => e.actiu);

// La edición que sirve una página de esta web, para que la página pueda leer
// lo suyo (por ahora, el vídeo) del mismo sitio que la rejilla.
export const edicioPerRuta = (ruta) => EDICIONS.find((e) => e.ruta === ruta) || null;

// Texto de la próxima edición en un idioma, con el catalán de reserva.
export const proximaText = (lang) =>
  PROXIMA && {
    etiqueta: PROXIMA.etiqueta[lang] || PROXIMA.etiqueta.ca,
    dates: PROXIMA.dates[lang] || PROXIMA.dates.ca,
  };

// Festival days (dated shows only), including multi-day ranges (dies)
export const FESTIVAL_DAYS = Array.from(
  new Set(
    data.shows.flatMap((s) => [...(s.dia ? [s.dia] : []), ...(s.dies || [])])
  )
).sort();

// Unique disciplines per language
export const disciplinesFor = (lang) => {
  const set = new Set();
  ALL_ITEMS.forEach((s) => {
    if (s.disciplina && s.disciplina[lang]) set.add(s.disciplina[lang]);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b));
};

// Format an ISO date (YYYY-MM-DD) -> e.g. "01 Ago"
export const formatDay = (iso, months) => {
  if (!iso) return '';
  const [, m, d] = iso.split('-');
  return `${d} ${months[parseInt(m, 10) - 1]}`;
};

export const formatFullDate = (iso, months) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d} ${months[parseInt(m, 10) - 1]} ${y}`;
};
